import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Quiz from './components/Quiz';

const pastelTheme = createTheme({
  palette: {
    primary: {
      main: '#a3c9f9', // pastel blue
      contrastText: '#222',
    },
    secondary: {
      main: '#f9a3c9', // pastel pink
    },
    background: {
      default: '#f6f8fc', // very light pastel
      paper: '#fff',
    },
    success: {
      main: '#b6e2d3', // pastel green
    },
    warning: {
      main: '#ffe5b4', // pastel orange
    },
    error: {
      main: '#ffb3b3', // pastel red
    },
  },
  typography: {
    fontFamily: '"Baloo 2", Arial, sans-serif',
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 700 },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#fdf6fb', // pastel card background
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
        },
      },
    },
  },
});

const App: React.FC = () => (
  <ThemeProvider theme={pastelTheme}>
    <CssBaseline />
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<Quiz />} />
      </Routes>
    </Router>
  </ThemeProvider>
);

export default App;